module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-6.ba0254ff.jpg";